import * as commonConst from '../../common/constants';
import * as step4Const from './constants';
import * as service from './service';
import Vue from 'vue';

export default {
    [step4Const.getAvoidList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.getAvoidList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.getAvoidList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.getTagKeysList](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.getTagKeysList);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.getTagKeysList, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.getProjects](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(service.getProjects,{params:params});
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                data.ListProjectResult.ProjectList = _.orderBy(data.ListProjectResult.ProjectList, 'ProjectId', 'asc');
                ctx.commit(step4Const.getProjects, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.describeTagValues](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.describeTagValues);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.describeTagValues, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.getAvoidPackage](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.getAvoidPackage);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.getAvoidPackage, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.createAviod](ctx, params) {
        return new Promise ((resolve, reject) => {
            params = _.merge(params, service.createAviod);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.createAviod, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.calcAvoidPrice](ctx, params) {
        params = _.merge(params, service.calcAvoidPrice);
        return new Promise ((resolve, reject) => {
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.calcAvoidPrice, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    [step4Const.describeKeys](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.describeKeys);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.describeKeys, data);
                resolve();
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },
    
    //获取kec服务下所有IAM角色列表
    [step4Const.describeKecIamRoles](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.describeKecIamRoles);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                ctx.commit(step4Const.describeKecIamRoles, data);
                resolve(data);
            }).catch(e => {
                reject(e);
            }).then(() => {
                resolve();
            });
        });
    },

    [step4Const.getTimeddelDate](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.getTimeddelDate);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => { 
                resolve(data);
            }).catch(e => {
                ctx.commit(step4Const.getTimeddelDate, e);
                reject(e);
            });
        });
    },

    // 校验秘钥是否为2048位加密
    [step4Const.CheckKeyEncryption](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, service.CheckKeyEncryption);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => { 
                resolve(data);
            }).catch(e => {
                reject(e);
            });
        });
    },
}